'use client';

import Link from 'next/link';
import type { ComponentPropsWithoutRef } from 'react';

import { getBaseUrlJoined, trackContentfulClick } from '@libs/analytics';

import type { LearningCenterSpeciesEntriesItem } from './types';

type Props = Omit<ComponentPropsWithoutRef<typeof Link>, 'href'> & {
    position: number;
    item: LearningCenterSpeciesEntriesItem;
    pageHeadline: string;
};

export function LearningCenterArticleLink({ position, item, pageHeadline, onClick, ...props }: Props) {
    return (
        <Link
            href={`/${item.fields.pageId}`}
            onClick={e => {
                trackContentfulClick({
                    position,
                    linkText: item.fields.headline.toLowerCase(),
                    linkUrl: getBaseUrlJoined(item.fields.pageId) ?? '',
                    promoTitle: pageHeadline.toLowerCase(),
                    promoVariant: 'learning center article',
                    skipEcommerceCleanup: true,
                });
                onClick?.(e);
            }}
            {...props}
        />
    );
}
